import restCrudActions from '../../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../../np-rest/rest';
import { snackActions } from '../../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'products/list-reports',
    pluginName: 'REPORT',
    entityName: 'REPORT',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch report action creators
export const fetchReportInit = () => {
    return crudActions.fetchInit();
};
export const fetchReportStart = () => {
    return crudActions.fetchStart();
};
export const fetchReportSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchReportFail = () => {
    return crudActions.fetchFail();
};
export const fetchReportCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            let countRes = await rest.post("report/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch report."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch report."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};

export const fetchReport = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let listRes = await rest.post("report/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                return { data: listRes.data.result.data };
            }
            return { data: [] };
        }
        catch (error) {

            return { data: [] };
        }
    }
};

export const regenerateReport = (data) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let result = await rest.post("/report/re-generate", data);
            if (result.data && result.data.succeeded) {
                return { data: result };
            }
            snackActions.snackBar({
                message: `${result.data ? result.data.message : result.message}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: null };
        }
        catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: null };
        }
    }
}